module.exports = __webpack_public_path__ + "media/landing_page/calendar-icon-fd285372.svg";